<template>
  <div>
    <v-container fluid>
      <div class="main-section-title mb-4">Pre-school Details View</div>
      <!-- Basic Information -->
      <div class="section-wrapper">
        <div class="tab-label">
          <span>Basic Information</span>
        </div>
        <v-card class="basic-info-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="preSchoolNameText"
                  label="1. Preschool Name"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.district"
                  label="2. District"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.block"
                  label="3. Block"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.village"
                  label="4. Village"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.nearestPrimarySchool"
                  label="5. Nearest Primary School"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.cluster"
                  label="6. Cluster"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.preSchoolNumber"
                  label="7. Pre-School Number"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.addressLandmark"
                  label="8. Address / Landmark"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.management"
                  label="9. Management"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.medium"
                  label="10. Medium"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.category"
                  label="11. Category"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.preSchoolEmail"
                  label="12. Pre-School Email"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.preSchoolContactNo"
                  label="13. Pre-School Contact No."
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.academicYearStarted"
                  label="14. Academic Year Started"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.preSchoolWebsite"
                  label="15. Pre-School Website"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.lowestClass"
                  label="16. Lowest Class"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.highestClass"
                  label="17. Highest Class"
                  outlined dense readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <!-- Management Details -->
      <div class="section-wrapper">
        <div class="tab-label">
          <span>Management Details</span>
        </div>
        <v-card class="basic-info-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.representativeName"
                  label="1. Management Representative Name"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.representativeEmail"
                  label="2. Management Representative Email"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.representativeMobile"
                  label="3. Management Representative Mobile"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.representativeDesignation"
                  label="4. Management Representative Designation"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.schoolRegistrationNumber"
                  label="5. School Registration Number"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.principalName"
                  label="6. Principal Name"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.principalEmail"
                  label="7. Principal Email"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.principalMobile"
                  label="8. Principal Mobile"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.principalHighestQualification"
                  label="9. Principal Highest Qualification"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.principalProfessionalQualification"
                  label="10. Principal Professional Qualification"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <label>11. Principal Certificate</label>
                <div v-if="viewData.principalCertificate && viewData.principalCertificate !== 'null' && viewData.principalCertificate !== ''">
                    <v-btn small color="primary" @click="downloadCertificate(viewData.principalCertificate)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                        View Existing PDF
                    </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <!-- Student and Classroom Details -->
      <div class="section-wrapper">
        <div class="tab-label">
          <span>Student and Classroom Details</span>
        </div>
        <v-card class="basic-info-card">
          <v-card-text>
            <v-row>
              <!-- Nursery -->
              <v-col cols="12" md="4">
                <v-card class="student-class-card" flat>
                  <v-card-title class="justify-center font-weight-bold">Nursery</v-card-title>
                  <v-card-text>
                    <v-text-field
                      :value="viewData.totalnurseryboys"
                      label="Total No. of Boys"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="viewData.totalnurserygirls"
                      label="Total No. of Girls"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="Number(viewData.totalnurseryboys||0) + Number(viewData.totalnurserygirls||0)"
                      label="Total"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="viewData.nurserytotalClassrooms"
                      label="Total Classrooms"
                      outlined dense readonly
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <!-- PP II -->
              <v-col cols="12" md="4">
                <v-card class="student-class-card" flat>
                  <v-card-title class="justify-center font-weight-bold">PP II</v-card-title>
                  <v-card-text>
                    <v-text-field
                      :value="viewData.totalpp2boys"
                      label="Total No. of Boys"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="viewData.totalpp2girls"
                      label="Total No. of Girls"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="Number(viewData.totalpp2boys||0) + Number(viewData.totalpp2girls||0)"
                      label="Total"
                      outlined dense readonly
                    />
                    <v-text-field
                      :value="viewData.pp2totalClassrooms"
                      label="Total Classrooms"
                      outlined dense readonly
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <!-- Infrastructure Details -->
      <div class="section-wrapper">
        <div class="tab-label">
          <span>Infrastructure Details</span>
        </div>
        <v-card class="basic-info-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <span class="font-weight-bold">1. Building</span>
                <v-text-field
                  :value="viewData.buildingType"
                  label="Building Type"
                  outlined dense readonly
                />
                <label>Building Completion Certificate</label>
                <div v-if="viewData.buildingCompletionCertificate && viewData.buildingCompletionCertificate !== 'null' && viewData.buildingCompletionCertificate !== ''">
                    <v-btn small color="primary" @click="downloadCertificate(viewData.buildingCompletionCertificate)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                        View Existing PDF
                    </v-btn>
                  </div>
              </v-col>
              <v-col cols="12" md="2">
                <span class="font-weight-bold">2. Health Hygiene Maintained?</span>
                <v-text-field
                  :value="boolToYesNo(viewData.healthHygieneMaintained)"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="2">
                <span class="font-weight-bold">3. Sanitation Maintained?</span>
                <v-text-field
                  :value="boolToYesNo(viewData.sanitationMaintained)"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <span class="font-weight-bold">4. Cleanliness Maintained?</span>
                <v-text-field
                  :value="boolToYesNo(viewData.cleanlinessMaintained)"
                  outlined dense readonly
                />
                <label>Cleanliness Maintenance Certificate</label>
                <div v-if="viewData.cleanlinessMaintenanceCertificate && viewData.cleanlinessMaintenanceCertificate !== 'null' && viewData.cleanlinessMaintenanceCertificate !== ''">
                    <v-btn small color="primary" @click="downloadCertificate(viewData.cleanlinessMaintenanceCertificate)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                        View Existing PDF
                    </v-btn>
                  </div>
              </v-col>
              <v-col cols="12" md="2">
                <span class="font-weight-bold">5. Facility</span>
                <v-text-field
                  :value="facilityList"
                  outlined dense readonly
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <span class="font-weight-bold">6. Total Number of Washrooms</span>
                <v-text-field
                  :value="viewData.totalWashrooms"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <span class="font-weight-bold">7. Area of Pre-School (Sq ft)</span>
                <v-text-field
                  :value="viewData.areapreSchoolsqft"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <span class="font-weight-bold">8. Water Storage Capacity (Liters)</span>
                <v-text-field
                  :value="viewData.waterStorageCapacityLiters"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="6">
                <span class="font-weight-bold">9. Attendants Available?</span>
                <v-text-field
                  :value="boolToYesNo(viewData.attendantsAvailable)"
                  outlined dense readonly
                />
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      :value="viewData.attendantsMale"
                      label="Male"
                      outlined dense readonly
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :value="viewData.attendantsFemale"
                      label="Female"
                      outlined dense readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="2">
                <span class="font-weight-bold">10. Children With Special Needs</span>
                <v-text-field
                  :value="boolToYesNo(viewData.childrenSpecialneeds)"
                  outlined dense readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <!-- Staff Details -->
      <div class="section-wrapper">
        <div class="tab-label">
          <span>Staff Details</span>
        </div>
        <v-card class="staff-info-card">
          <v-card-text>
            <div v-for="(viewData, idx) in staffArray" :key="idx">
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffName"
                  label="Name"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffType"
                  label="Teaching Type"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffHighestedu"
                  label="Highest Educational Qualification"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffProfessionalQualification"
                  label="Professional Qualification"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffDateOfBirth"
                  label="Date of Birth"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffDateOfJoin"
                  label="Date of Joining"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffGender"
                  label="Gender"
                  outlined dense readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  :value="viewData.staffCertifications"
                  label="Professional Qualification Certifications"
                  outlined dense readonly
                />
              </v-col>
            </v-row>
            <v-divider class="my-4" v-if="idx < staffArray.length - 1" />
            </div>
          </v-card-text>
        </v-card>
      </div>
      <v-btn color="grey" elevation="1" class="ml-2" @click="cancelEdit">
          <v-icon left>mdi-cancel</v-icon>
          Cancel
        </v-btn>
      <v-btn class="ml-2" color="primary" elevation="1" @click="downloadCSV()">
        <v-icon left size="18">mdi-download</v-icon>Download CSV
      </v-btn>
      <v-btn class="ml-2" color="primary" elevation="1" @click="downloadFormPDF()">
        <v-icon left size="18">mdi-download</v-icon>Download PDF
      </v-btn>
    </v-container>
  <div v-show="printMode" id="printableSummary">
    <h2 style="color:#0284df; text-align:center; font-size:2rem; font-weight:bold; margin:28px 0 18px 0;">Pre-school Details</h2>
  <!-- Basic Information -->
  <div style="border:2px solid #0284df; border-radius:16px; background:#eaf6ff; margin-bottom:32px; padding-top:32px; position:relative;">
    <div style="position:absolute; top:-22px; left:18px; background:#0284df; color:#fff; border-radius:8px 8px 0 0; padding:4px 28px; font-weight:700; font-size:20px;">
      Basic Information
    </div>
    <table style="width:100%; border:none; margin-top:6px;">
      <tr>
        <td>1. Preschool Name</td>
        <td>2. District</td>
        <td>3. Block</td>
        <td>4. Village</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ preSchoolNameText }}</div></td>
        <td><div class="form-box">{{ viewData.district }}</div></td>
        <td><div class="form-box">{{ viewData.block }}</div></td>
        <td><div class="form-box">{{ viewData.village }}</div></td>
      </tr>
      <tr>
        <td>5. Nearest Primary School</td>
        <td>6. Cluster</td>
        <td>7. Pre-School Number</td>
        <td>8. Address / Landmark</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.nearestPrimarySchool }}</div></td>
        <td><div class="form-box">{{ viewData.cluster }}</div></td>
        <td><div class="form-box">{{ viewData.preSchoolNumber }}</div></td>
        <td><div class="form-box">{{ viewData.addressLandmark }}</div></td>
      </tr>
      <tr>
        <td>9. Management</td>
        <td>10. Medium</td>
        <td>11. Category</td>
        <td>12. Pre-School Email</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.management }}</div></td>
        <td><div class="form-box">{{ viewData.medium }}</div></td>
        <td><div class="form-box">{{ viewData.category }}</div></td>
        <td><div class="form-box">{{ viewData.preSchoolEmail }}</div></td>
      </tr>
      <tr>
        <td>13. Pre-School Contact No.</td>
        <td>14. Academic Year Started</td>
        <td>15. Pre-School Website</td>
        <td>16. Lowest Class</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.preSchoolContactNo }}</div></td>
        <td><div class="form-box">{{ viewData.academicYearStarted }}</div></td>
        <td><div class="form-box">{{ viewData.preSchoolWebsite }}</div></td>
        <td><div class="form-box">{{ viewData.lowestClass }}</div></td>
      </tr>
      <tr>
        <td>17. Highest Class</td><td></td><td></td><td></td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.highestClass }}</div></td><td></td><td></td><td></td>
      </tr>
    </table>
  </div>

  <!-- Management Details -->
  <div style="border:2px solid #0284df; border-radius:16px; background:#eaf6ff; margin-bottom:32px; padding-top:32px; position:relative;">
    <div style="position:absolute; top:-22px; left:18px; background:#0284df; color:#fff; border-radius:8px 8px 0 0; padding:4px 28px; font-weight:700; font-size:20px;">
      Management Details
    </div>
    <table style="width:100%; border:none; margin-top:6px;">
      <tr>
        <td>1. Management Representative Name</td>
        <td>2. Management Representative Email</td>
        <td>3. Management Representative Mobile</td>
        <td>4. Management Representative Designation</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.representativeName }}</div></td>
        <td><div class="form-box">{{ viewData.representativeEmail }}</div></td>
        <td><div class="form-box">{{ viewData.representativeMobile }}</div></td>
        <td><div class="form-box">{{ viewData.representativeDesignation }}</div></td>
      </tr>
      <tr>
        <td>5. School Registration Number</td>
        <td>6. Principal Name</td>
        <td>7. Principal Email</td>
        <td>8. Principal Mobile</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.schoolRegistrationNumber }}</div></td>
        <td><div class="form-box">{{ viewData.principalName }}</div></td>
        <td><div class="form-box">{{ viewData.principalEmail }}</div></td>
        <td><div class="form-box">{{ viewData.principalMobile }}</div></td>
      </tr>
      <tr>
        <td>9. Principal Highest Qualification</td>
        <td>10. Principal Professional Qualification</td>
        <td>11. Principal Certificate</td>
        <td></td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.principalHighestQualification }}</div></td>
        <td><div class="form-box">{{ viewData.principalProfessionalQualification }}</div></td>
        <td><div class="form-box">{{ viewData.principalCertificate ? 'Uploaded' : 'Not Uploaded' }}</div></td>
        <td></td>
      </tr>
    </table>
  </div>

  <!-- Student and Classroom Details -->
  <div style="border:2px solid #0284df; border-radius:16px; background:#eaf6ff; margin-bottom:32px; padding-top:32px; position:relative;">
    <div style="position:absolute; top:-22px; left:18px; background:#0284df; color:#fff; border-radius:8px 8px 0 0; padding:4px 28px; font-weight:700; font-size:20px;">
      Student and Classroom Details
    </div>
    <table style="width:100%; border:none; margin-top:6px;">
      <tr>
        <td>Nursery - Boys</td>
        <td>Nursery - Girls</td>
        <td>Nursery - Total</td>
        <td>Nursery - Classrooms</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.totalnurseryboys }}</div></td>
        <td><div class="form-box">{{ viewData.totalnurserygirls }}</div></td>
        <td><div class="form-box">{{ Number(viewData.totalnurseryboys||0) + Number(viewData.totalnurserygirls||0) }}</div></td>
        <td><div class="form-box">{{ viewData.nurserytotalClassrooms }}</div></td>
      </tr>
      <tr>
        <td>PP II - Boys</td>
        <td>PP II - Girls</td>
        <td>PP II - Total</td>
        <td>PP II - Classrooms</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.totalpp2boys }}</div></td>
        <td><div class="form-box">{{ viewData.totalpp2girls }}</div></td>
        <td><div class="form-box">{{ Number(viewData.totalpp2boys||0) + Number(viewData.totalpp2girls||0) }}</div></td>
        <td><div class="form-box">{{ viewData.pp2totalClassrooms }}</div></td>
      </tr>
    </table>
  </div>
<!-- Infrastructure Details -->
  <div style="border:2px solid #0284df; border-radius:16px; background:#eaf6ff; margin-bottom:32px; padding-top:32px; position:relative;">
    <div style="position:absolute; top:-22px; left:18px; background:#0284df; color:#fff; border-radius:8px 8px 0 0; padding:4px 28px; font-weight:700; font-size:20px;">
      Infrastructure Details
    </div>
    <table style="width:100%; border:none; margin-top:6px;">
      <tr>
        <td>1. Building Type</td>
        <td> Building Completion Certificate</td>
        <td>2. Health Hygiene Maintained?</td>
        <td>3. Sanitation Maintained?</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.buildingType }}</div></td>
        <td>
          <div class="form-box">
            <span v-if="viewData.buildingCompletionCertificate">Uploaded</span>
            <span v-else>Not Uploaded</span>
          </div>
        </td>
        <td><div class="form-box">{{ boolToYesNo(viewData.healthHygieneMaintained) }}</div></td>
        <td><div class="form-box">{{ boolToYesNo(viewData.sanitationMaintained) }}</div></td>
      </tr>
      <tr>
        <td>4. Cleanliness Maintained?</td>
        <td> Cleanliness Maintenance Certificate</td>
        <td>5. Facility</td>
        <td>6. Total Washrooms</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ boolToYesNo(viewData.cleanlinessMaintained) }}</div></td>
        <td>
          <div class="form-box">
            <span v-if="viewData.cleanlinessMaintenanceCertificate">Uploaded</span>
            <span v-else>Not Uploaded</span>
          </div>
        </td>
        <td><div class="form-box">{{ facilityList }}</div></td>
        <td><div class="form-box">{{ viewData.totalWashrooms }}</div></td>
      </tr>
      <tr>
        <td>7. Area (Sq ft)</td>
        <td>8. Water Storage (Liters)</td>
        <td>9. Attendants Available?</td>
        <td> Attendants Male</td>
        <td> Attendants Female</td>
        <td>10. Children With Special Needs</td>
      </tr>
      <tr>
        <td><div class="form-box">{{ viewData.areapreSchoolsqft }}</div></td>
        <td><div class="form-box">{{ viewData.waterStorageCapacityLiters }}</div></td>
        <td><div class="form-box">{{ boolToYesNo(viewData.attendantsAvailable) }}</div></td>
        <td><div class="form-box">{{ viewData.attendantsMale }}</div></td>
        <td><div class="form-box">{{ viewData.attendantsFemale }}</div></td>
        <td><div class="form-box">{{ boolToYesNo(viewData.childrenSpecialneeds) }}</div></td>
      </tr>
    </table>
  </div>
  <!-- Staff Details -->
  <div style="border:2px solid #0284df; border-radius:16px; background:#eaf6ff; margin-bottom:32px; padding-top:32px; position:relative;">
    <div style="position:absolute; top:-22px; left:18px; background:#0284df; color:#fff; border-radius:8px 8px 0 0; padding:4px 28px; font-weight:700; font-size:20px;">
      Staff Details
    </div>
    <table style="width:100%; border-collapse:collapse; margin-top:10px;">
      <thead>
        <tr>
          <th style="text-align:left;">Name</th>
          <th style="text-align:left;">Teaching Type</th>
          <th style="text-align:left;">Highest Education</th>
          <th style="text-align:left;">Professional Qualification</th>
          <th style="text-align:left;">Date of Birth</th>
          <th style="text-align:left;">Date of Joining</th>
          <th style="text-align:left;">Gender</th>
          <th style="text-align:left;">Certifications</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(staff, idx) in staffArray" :key="idx">
          <td><div class="form-box">{{ staff.staffName }}</div></td>
          <td><div class="form-box">{{ staff.staffType }}</div></td>
          <td><div class="form-box">{{ staff.staffHighestedu }}</div></td>
          <td><div class="form-box">{{ staff.staffProfessionalQualification }}</div></td>
          <td><div class="form-box">{{ staff.staffDateOfBirth }}</div></td>
          <td><div class="form-box">{{ staff.staffDateOfJoin }}</div></td>
          <td><div class="form-box">{{ staff.staffGender }}</div></td>
          <td><div class="form-box">{{ staff.staffCertifications }}</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
    <v-card-component >
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Logs : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card-text>

        <v-divider class=" my-0 " />
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="preschoollist"
          :search="search"
        >
        <template v-slot:item.createdAt="{ item }">
          {{ new Date(item.createdAt).toLocaleDateString() }}
        </template>
          <template v-slot:item.preSchoolName="{ item }">
            {{ item.preSchoolName || '-' }}
          </template>
          <template v-slot:item.district="{ item }">
            {{ item.district || '-' }}
          </template>
          <template v-slot:item.village="{ item }">
            {{ item.village || '-' }}
          </template>
          <template v-slot:item.lowestClass="{ item }">
            {{ item.lowestClass || '-' }}
          </template>
          <template v-slot:item.updatedBy="{ item }">
            {{ item.updatedBy || '-' }}
          </template>
          <template v-slot:item.healthHygieneMaintained="{ item }">
            {{ item.healthHygieneMaintained === true || item.healthHygieneMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.sanitationMaintained="{ item }">
            {{ item.sanitationMaintained === true || item.sanitationMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.cleanlinessMaintained="{ item }">
            {{ item.cleanlinessMaintained === true || item.cleanlinessMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.attendantsAvailable="{ item }">
            {{ item.attendantsAvailable === true || item.attendantsAvailable === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.childrenSpecialneeds="{ item }">
            {{ item.childrenSpecialneeds === true || item.childrenSpecialneeds === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        </v-card-component>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
import constants from '@/utils/constants'
export default {
  name: 'viewpreschooldetails',
  props: { id: { type: String, required: true } },
  data () {
    return {
      viewData: {},
      isLoading: true,
      classesToShow: [
        { text: 'Nursery', value: 'nursery' },
        { text: 'PP II', value: 'pp2' }
      ],
      allFranchisees: [],
      total: 0,
      search: '',
      preschoollist: [],
      headers: [
        { text: 'Date', value: 'createdAt', sortable: true },
        { text: 'Franchisee/Center', value: 'franchisee.companyName', sortable: true },
        { text: 'District', value: 'district', sortable: true },
        { text: 'Block', value: 'centerDetails.block', sortable: true },
        { text: 'Village', value: 'village', sortable: true },
        { text: 'Nearest Primary School', value: 'nearestPrimarySchool', sortable: true },
        { text: 'Cluster', value: 'cluster', sortable: true },
        { text: 'Pre-School Number', value: 'preSchoolNumber', sortable: true },
        { text: 'Address / Landmark', value: 'addressLandmark', sortable: true },
        { text: 'Management', value: 'management', sortable: true },
        { text: 'Medium', value: 'medium', sortable: true },
        { text: 'Category', value: 'category', sortable: true },
        { text: 'Pre-School Email', value: 'preSchoolEmail', sortable: true },
        { text: 'Pre-School Contact No', value: 'preSchoolContactNo', sortable: true },
        { text: 'Academic Year Started', value: 'academicYearStarted', sortable: true },
        { text: 'Pre-School Website', value: 'preSchoolWebsite', sortable: true },
        { text: 'Lowest Class', value: 'lowestClass', sortable: true },
        { text: 'Highest Class', value: 'highestClass', sortable: true },
        // Management Details
        { text: 'Mgmt Rep Name', value: 'representativeName', sortable: true },
        { text: 'Mgmt Rep Email', value: 'representativeEmail', sortable: true },
        { text: 'Mgmt Rep Mobile', value: 'representativeMobile', sortable: true },
        { text: 'Mgmt Rep Designation', value: 'representativeDesignation', sortable: true },
        { text: 'School Registration No', value: 'schoolRegistrationNumber', sortable: true },
        { text: 'Principal Name', value: 'principalName', sortable: true },
        { text: 'Principal Email', value: 'principalEmail', sortable: true },
        { text: 'Principal Mobile', value: 'principalMobile', sortable: true },
        { text: 'Principal Highest Qual.', value: 'principalHighestQualification', sortable: true },
        { text: 'Principal Professional Qual.', value: 'principalProfessionalQualification', sortable: true },
        { text: 'Principal Certificate', value: 'principalCertificate', sortable: true },
        // Student/Classroom Details
        { text: 'Nursery Boys', value: 'totalnurseryboys', sortable: true },
        { text: 'Nursery Girls', value: 'totalnurserygirls', sortable: true },
        { text: 'Nursery Classrooms', value: 'nurserytotalClassrooms', sortable: true },
        { text: 'PP II Boys', value: 'totalpp2boys', sortable: true },
        { text: 'PP II Girls', value: 'totalpp2girls', sortable: true },
        { text: 'PP II Classrooms', value: 'pp2totalClassrooms', sortable: true },
        // Infrastructure Details
        { text: 'Building Type', value: 'buildingType', sortable: true },
        { text: 'Building Completion Certificate', value: 'buildingCompletionCertificate', sortable: true },
        { text: 'Health Hygiene Maintained', value: 'healthHygieneMaintained', sortable: true },
        { text: 'Sanitation Maintained', value: 'sanitationMaintained', sortable: true },
        { text: 'Cleanliness Maintained', value: 'cleanlinessMaintained', sortable: true },
        { text: 'Cleanliness Maintenance Certificate', value: 'cleanlinessMaintenanceCertificate', sortable: true },
        { text: 'Facility', value: 'facility', sortable: true },
        { text: 'Total Washrooms', value: 'totalWashrooms', sortable: true },
        { text: 'Area (sqft)', value: 'areapreSchoolsqft', sortable: true },
        { text: 'Water Storage (Liters)', value: 'waterStorageCapacityLiters', sortable: true },
        { text: 'Attendants Available', value: 'attendantsAvailable', sortable: true },
        { text: 'Attendants Male', value: 'attendantsMale', sortable: true },
        { text: 'Attendants Female', value: 'attendantsFemale', sortable: true },
        // Special Needs
        { text: 'Children with Special Needs', value: 'childrenSpecialneeds', sortable: true },
        { text: 'SN Nursery Boys', value: 'specialneedsNurseryBoys', sortable: true },
        { text: 'SN Nursery Girls', value: 'specialneedsNurseryGirls', sortable: true },
        { text: 'SN PP II Boys', value: 'specialneedsPP2Boys', sortable: true },
        { text: 'SN PP II Girls', value: 'specialneedsPP2Girls', sortable: true },
        // Staff Details (as joined strings)
        { text: 'Staff Names', value: 'staffName', sortable: true },
        { text: 'Staff Types', value: 'staffType', sortable: true },
        { text: 'Staff Highest Edu.', value: 'staffHighestedu', sortable: true },
        { text: 'Staff Professional Qual.', value: 'staffProfessionalQualification', sortable: true },
        { text: 'Staff DOBs', value: 'staffDateOfBirth', sortable: true },
        { text: 'Staff DOJs', value: 'staffDateOfJoin', sortable: true },
        { text: 'Staff Genders', value: 'staffGender', sortable: true },
        { text: 'Staff Certifications', value: 'staffCertifications', sortable: true },
        { text: 'Edited By', value: 'updatedBy', sortable: true }
      ],
      printMode: false,
      infra: {
        buildingType: '',
        buildingCert: null,
        healthHygiene: '',
        sanitation: '',
        cleanliness: '',
        cleanlinessCert: null,
        facility: [],
        washrooms: '',
        area: '',
        waterStorage: '',
        attendants: '',
        specialNeeds: '',
        attendantMale: 0,
        attendantFemale: 0
      },
      staffList: [
        {
          name: '',
          type: '',
          highestEdu: '',
          profQualification: '',
          dob: '',
          doj: '',
          gender: '',
          certifications: []
        }
      ],
      allClasses: [
        { text: 'Nursery', value: 'nursery' },
        { text: 'PP II', value: 'pp II' }
      ]
    }
  },
  created () {
    if (this.id) this.fetchCenterDetails(this.id)
    this.getAllFranchisee()
    this.getCenterLogDetails()
  },
  watch: {
    viewData: {
      handler (val) {
        if (val && val.preSchoolName) {
          this.getCenterLogDetails()
        }
      },
      immediate: true
    }
  },
  computed: {
    facilityList () {
      if (!this.viewData.facility) return ' '
      try {
        const arr = JSON.parse(this.viewData.facility)
        return Array.isArray(arr) && arr.length ? arr.join(', ') : ' '
      } catch {
        return ' '
      }
    },
    preSchoolNameText () {
      if (!this.allFranchisees || !this.viewData.preSchoolName) return this.viewData.preSchoolName
      const match = this.allFranchisees.find(f => String(f.id) === String(this.viewData.preSchoolName))
      return match ? match.companyName : this.viewData.preSchoolName
    },
    staffArray () {
      const names = (this.viewData.staffName || '').split(',').map(s => s.trim())
      const types = (this.viewData.staffType || '').split(',').map(s => s.trim())
      const highestEdus = (this.viewData.staffHighestedu || '').split(',').map(s => s.trim())
      const profQualifications = (this.viewData.staffProfessionalQualification || '').split(',').map(s => s.trim())
      const dobs = (this.viewData.staffDateOfBirth || '').split(',').map(s => s.trim())
      const dojs = (this.viewData.staffDateOfJoin || '').split(',').map(s => s.trim())
      const genders = (this.viewData.staffGender || '').split(',').map(s => s.trim())
      const certs = (this.viewData.staffCertifications || '').split(',').map(s => s.trim())
      // Build array of staff objects
      return names.map((staffName, i) => ({
        staffName,
        staffType: types[i] || '',
        staffHighestedu: highestEdus[i] || '',
        staffProfessionalQualification: profQualifications[i] || '',
        staffDateOfBirth: dobs[i] || '',
        staffDateOfJoin: dojs[i] || '',
        staffGender: genders[i] || '',
        staffCertifications: certs[i] || ''
      })).filter(staff =>
        staff.staffName ||
        staff.staffType ||
        staff.staffHighestedu ||
        staff.staffProfessionalQualification ||
        staff.staffDateOfBirth ||
        staff.staffDateOfJoin ||
        staff.staffGender ||
        staff.staffCertifications
      )
    }
  },
  methods: {
    async fetchCenterDetails (id) {
      this.isLoading = true
      try {
        let result = await http.get(
          `${constants.API_URL}/api/centerdetailsPreschool/centerdetails/${id}`
        )
        this.getCenterLogDetails()
        if (this.viewData.length > 0) {
          this.populateFormFromLog(this.viewData[0])
        }
        // API returns { success: true, data: {...} }
        this.viewData = (result.data && result.data.data) ? result.data.data : {}
      } catch (e) {
        this.viewData = {}
      } finally {
        this.isLoading = false
      }
    },
    getFileUrl (path) {
      if (!path || path === 'null') return ''
      if (/^https?:\/\//.test(path)) return path
      return `/uploads/${path}`
    },
    extractS3Key (url) {
      const base = 'https://intellitots.s3.ap-south-1.amazonaws.com/'
      if (url.startsWith(base)) {
        let key = url.substring(base.length)
        try {
          key = decodeURIComponent(key)
        } catch (e) {}
        if (key.match(/%[0-9A-Fa-f]{2}/)) {
          key = decodeURIComponent(key)
        }
        return key
      }
      return url
    },
    downloadCertificate: async function (fileUrlOrKey) {
      const s3key = this.extractS3Key(fileUrlOrKey)
      let response = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${encodeURIComponent(s3key)}`)
      window.open(response.data)
    },
    boolToYesNo (val) {
      if (val === true) return 'Yes'
      if (val === false) return 'No'
      return '-'
    },
    getAllFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.allFranchisees = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    cancelEdit () {
      this.$router.go(-1)
    },
    async getCenterLogDetails () {
      this.isLoading = true
      try {
        let schoolName = this.viewData.preSchoolName
        const match = this.allFranchisees.find(f => String(f.id) === String(schoolName))
        if (match) schoolName = match.companyName
        if (!schoolName) {
          this.preschoollist = []
          this.total = 0
          this.isLoading = false
          return
        }
        let result = await http.get(
          `${constants.API_URL}/api/centerdetailsPreschool/viewpreschoollog?preSchoolName=${encodeURIComponent(schoolName)}`
        )
        console.log(`Fetched logs for preSchoolName: ${schoolName}`, result.data)
        this.preschoollist = result.data
        this.total = this.preschoollist.length
      } catch (e) {
        this.preschoollist = []
      } finally {
        this.isLoading = false
      }
    },
    downloadCSV () {
      const obj = { ...this.viewData }
      if (!obj || !Object.keys(obj).length) {
        alert('No data available to download.')
        return
      }
      const booleanFields = [
        'healthHygieneMaintained',
        'sanitationMaintained',
        'cleanlinessMaintained',
        'attendantsAvailable',
        'childrenSpecialneeds'
      ]
      delete obj.deletedAt
      delete obj.id
      delete obj.franchiseeID
      delete obj.zoneId
      booleanFields.forEach(key => {
        if (obj.hasOwnProperty(key)) {
          obj[key] = obj[key] === true || obj[key] === 'true' ? 'Yes' : 'No'
        }
      })
      if (Array.isArray(obj.facility)) {
        obj.facility = obj.facility.length ? obj.facility.join(', ') : ''
      } else if (typeof obj.facility === 'string') {
        try {
          const arr = JSON.parse(obj.facility)
          obj.facility = Array.isArray(arr) && arr.length ? arr.join(', ') : ' '
        } catch {
        }
      }
      const franchiseeObj = this.allFranchisees.find(f => String(f.id) === String(obj.preSchoolName))
      obj.preSchoolName = franchiseeObj ? franchiseeObj.companyName : obj.preSchoolName
      function escapeCSVField (value) {
        if (value === null || value === undefined) return ''
        if (typeof value === 'object') value = JSON.stringify(value)
        value = value.toString()
        if (/[",\n]/.test(value)) {
          value = '"' + value.replace(/"/g, '""') + '"'
        }
        return value
      }
      const headers = Object.keys(obj)
      const headerRow = headers.join(',')
      const valueRow = headers.map(key => escapeCSVField(obj[key])).join(',')
      const csvContent = [headerRow, valueRow].join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', 'preschooldetails.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    populateFormFromLog () {
      this.preschoolname = this.viewData.preSchoolName || ''
      this.district = this.viewData.district || ''
      this.block = this.viewData.block || ''
      this.village = this.viewData.village || ''
      this.nearestPrimarySchool = this.viewData.nearestPrimarySchool || ''
      this.cluster = this.viewData.cluster || ''
      this.preschoolnumber = this.viewData.preSchoolNumber || ''
      this.address = this.viewData.addressLandmark || ''
      this.management = this.viewData.management || ''
      this.medium = this.viewData.medium || ''
      this.category = this.viewData.category || ''
      this.preschoolEmail = this.viewData.preSchoolEmail || ''
      this.preschoolContactNo = this.viewData.preSchoolContactNo || ''
      this.preschoolacademicYear = this.viewData.academicYearStarted || ''
      this.preschoolwebsite = this.viewData.preSchoolWebsite || ''
      this.lowestClass = this.viewData.lowestClass || ''
      this.highestClass = this.viewData.highestClass || ''
      // Management Details
      this.managementreptname = this.viewData.representativeName || ''
      this.managementreptemail = this.viewData.representativeEmail || ''
      this.managementreptmobile = this.viewData.representativeMobile || ''
      this.managementreptdesignation = this.viewData.representativeDesignation || ''
      this.schoolregistrationnumber = this.viewData.schoolRegistrationNumber || ''
      this.principalname = this.viewData.principalName || ''
      this.principalemail = this.viewData.principalEmail || ''
      this.principalmobile = this.viewData.principalMobile || ''
      this.principalhighqualification = this.viewData.principalHighestQualification || ''
      this.principalprofqualification = this.viewData.principalProfessionalQualification || ''
      this.principalCertificate = this.viewData.principalCertificate || null
      // Class/Student Details
      this.classDetails = this.classDetails || {
        nursery: { boys: '', girls: '', classrooms: '' },
        'pp II': { boys: '', girls: '', classrooms: '' }
      }
      this.nursery.boys = this.viewData.totalnurseryboys || ''
      this.nursery.girls = this.viewData.totalnurserygirls || ''
      this.classDetails.nursery.classrooms = this.viewData.nurserytotalClassrooms || ''
      this.classDetails['pp II'].boys = this.viewData.totalpp2boys || ''
      this.classDetails['pp II'].girls = this.viewData.totalpp2girls || ''
      this.classDetails['pp II'].classrooms = this.viewData.pp2totalClassrooms || ''
      // Infrastructure Details
      this.infra = this.infra || {
        buildingType: '',
        buildingCert: null,
        healthHygiene: '',
        sanitation: '',
        cleanliness: '',
        cleanlinessCert: null,
        facility: [],
        washrooms: '',
        area: '',
        waterStorage: '',
        attendants: '',
        specialNeeds: '',
        attendantMale: 0,
        attendantFemale: 0
      }
      this.infra.buildingType = this.viewData.buildingType || ''
      this.infra.buildingCert = this.viewData.buildingCompletionCertificate || null
      this.infra.healthHygiene = this.viewData.healthHygieneMaintained ? 'yes' : 'no'
      this.infra.sanitation = this.viewData.sanitationMaintained ? 'yes' : 'no'
      this.infra.cleanliness = this.viewData.cleanlinessMaintained ? 'yes' : 'no'
      this.infra.cleanlinessCert = this.viewData.cleanlinessMaintenanceCertificate || null
      this.infra.facility = this.viewData.facility ? JSON.parse(this.viewData.facility) : []
      this.infra.washrooms = this.viewData.totalWashrooms || ''
      this.infra.area = this.viewData.areapreSchoolsqft || ''
      this.infra.waterStorage = this.viewData.waterStorageCapacityLiters || ''
      this.infra.attendants = this.viewData.attendantsAvailable ? 'yes' : 'no'
      this.infra.attendantMale = this.viewData.attendantsMale || ''
      this.infra.attendantFemale = this.viewData.attendantsFemale || ''
      this.infra.specialNeeds = this.viewData.childrenSpecialneeds ? 'yes' : 'no'
      // Special Needs Details
      this.specialNeedsInput = this.specialNeedsInput || {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      }
      this.specialNeedsInput.nursery.boys = this.viewData.specialneedsNurseryBoys || ''
      this.specialNeedsInput.nursery.girls = this.viewData.specialneedsNurseryGirls || ''
      this.specialNeedsInput['pp II'].boys = this.viewData.specialneedsPP2Boys || ''
      this.specialNeedsInput['pp II'].girls = this.viewData.specialneedsPP2Girls || ''
      // Staff Details (multiple staff support)
      if (this.viewData.staffName) {
        const names = (this.viewData.staffName || '').split(',').map(x => x.trim())
        const types = (this.viewData.staffType || '').split(',').map(x => x.trim())
        const highestEdus = (this.viewData.staffHighestedu || '').split(',').map(x => x.trim())
        const profQualifications = (this.viewData.staffProfessionalQualification || '').split(',').map(x => x.trim())
        const dobs = (this.viewData.staffDateOfBirth || '').split(',').map(x => x.trim())
        const dojs = (this.viewData.staffDateOfJoin || '').split(',').map(x => x.trim())
        const genders = (this.viewData.staffGender || '').split(',').map(x => x.trim())
        const certsRaw = (this.viewData.staffCertifications || '').split(',').map(x => x.trim())
        const certifications = certsRaw.map(c => c ? c.split('|').map(y => y.trim()) : [])
        this.staffList = names.map((name, i) => ({
          name: name || '',
          type: types[i] || '',
          highestEdu: highestEdus[i] || '',
          profQualification: profQualifications[i] || '',
          dob: dobs[i] || '',
          doj: dojs[i] || '',
          gender: genders[i] || '',
          certifications: certifications[i] || []
        }))
        if (!this.staffList.length) {
          this.staffList = [{
            name: '',
            type: '',
            highestEdu: '',
            profQualification: '',
            dob: '',
            doj: '',
            gender: '',
            certifications: []
          }]
        }
      } else {
        // fallback for no staff
        this.staffList = [{
          name: '',
          type: '',
          highestEdu: '',
          profQualification: '',
          dob: '',
          doj: '',
          gender: '',
          certifications: []
        }]
      }
    },
    downloadFormPDF () {
      if (this.isZonalManager && this.preschoollist.length > 0) {
        this.populateFormFromLog(this.preschoollist[0])
      }
      this.printMode = true
      this.$nextTick(() => {
        this.printForm('printableSummary')
        setTimeout(() => {
          this.printMode = false
        }, 1000)
      })
    },
    printForm (contentId) {
      const el = document.getElementById(contentId)
      if (!el) {
        this.errMsg(`Element with id "${contentId}" not found!`)
        return
      }
      const htmlContent = el.innerHTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      const printWindow = window.open('', '', 'left=0,top=0,width=850,height=1200,toolbar=0,scrollbars=1,status=0')
      printWindow.document.write(`<!DOCTYPE html>
    <html>
    <head>
      <title>Pre-school Details PDF</title>
      ${stylesHtml}
    </head>
    <body>
      ${htmlContent}
    </body>
    <style>
      body, p { font-size: 10pt; font-family: Arial, Helvetica, sans-serif; }
      body { margin: 2em; }
    </style>
    </html>
  `)
      printWindow.document.close()
      printWindow.focus()
      setTimeout(function () {
        printWindow.print()
      }, 500)
    }
  }
}
</script>

<style scoped>
.main-section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #0284df;
  margin-top: 18px;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}
.section-wrapper {
  background: #eaf6ff;
  border-radius: 12px;
  padding: 24px 12px 12px 12px;
  margin-bottom: 32px;
  position: relative;
  border: 2px solid #0a0a0a;
}
.basic-info-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(2,132,223,0.04);
  background: #fff;
  margin-top: 18px;
}
.tab-label {
  position: absolute;
  top: -18px;
  left: 18px;
  background: #0284df;
  color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 4px 28px;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(2,132,223,0.14);
  z-index: 2;
}
.scroll-wrapper {
  overflow-x: auto;
  width: 100%;
}
.form-box {
  border: 1.5px solid #b3c3d6;
  background: #fff;
  border-radius: 7px;
  padding: 5px 12px;
  min-height: 28px;
  margin: 2px 0 4px 0;
  font-size: 1rem;
}
</style>
